import type React from 'react'
import type { UserDto } from '../../../../../types/coreApi-types'
import { getInitials } from '../../../../../utils/getInitials'

interface Props {
  member: UserDto
  disableActions?: boolean
}

const Member: React.FC<Props> = ({ member }) => {
  return (
    <div className="flex items-center justify-between ">
      <div className="gap-3 flex items-center">
        <div className="w-10 h-10 rounded-full border-[1px] border-black/10 border-solid flex items-center justify-center color-text-default text-xs font-semi bg-brand-light-background dark:bg-brand-dark-background">
          {getInitials(member.name)}
        </div>
        <div className="flex flex-col">
          <p className="text-default-small">{member.name}</p>
          <p className="text-description">{member.email}</p>
        </div>
      </div>
    </div>
  )
}

export default Member
